import {Button, Modal, Spinner} from "react-bootstrap";
import React from 'react';
import {useState} from "react";

export default function DeleteWaterSystemConfirmationModal({
                                                               setShow,
                                                               show,
                                                               isWaterSystemdDeletedSuccessfully
                                                           }) {

    const handleOk = async () => {
        setShow(false);
    }

    return (
        <Modal dialogClassName="filter-modal" show={show} onHide={() => setShow(false)}
               style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>{isWaterSystemdDeletedSuccessfully ?
                    <div>The water system has been successfully deleted</div> :
                    <div>Failed to delete the water system</div>}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    isWaterSystemdDeletedSuccessfully ?
                        <div> The water system and its associated components have been successfully removed.
                            Please refresh the page to get the latest updates.</div> :
                        <div>Failed to delete the water system, please ty again later.</div>
                }

            </Modal.Body>
            <Modal.Footer>
                <Button style={{width: 80}} onClick={() => handleOk()} variant="primary">OK</Button>
            </Modal.Footer>
        </Modal>
    )
}
